import AnimatedSection from '../common/AnimatedSection'
import {
  IconExcellence,
  IconIntegrity,
  IconPartnership,
  IconQuality,
  IconReliability,
} from '../icons/AboutValuesIcons'

const values = [
  {
    title: 'Integrity',
    text: 'We conduct our business with honesty, transparency, and ethical standards.',
    Icon: IconIntegrity,
  },
  {
    title: 'Quality',
    text: 'We ensure the highest quality in every product and service we deliver.',
    Icon: IconQuality,
  },
  {
    title: 'Reliability',
    text: 'Our clients trust us for consistent quality and dependable service.',
    Icon: IconReliability,
  },
  {
    title: 'Partnership',
    text: 'We believe in long-term partnerships built on trust and mutual growth.',
    Icon: IconPartnership,
  },
  {
    title: 'Excellence',
    text: 'We continuously strive for excellence in everything we do.',
    Icon: IconExcellence,
  },
]

function AboutValuesSection() {
  return (
    <AnimatedSection className="about-values-section">
      <div className="container corp-container">
        <header className="about-values-header">
          {/* <span className="section-label section-label--gold about-values-label">Our Values</span> */}
          <div className="about-vision-label">
              <span className="about-vision-label-line" aria-hidden="true"  style={{ height: '3px', width: '32px' }}/>
              <span>Our Values</span>
            </div>
          <h2 className="about-values-title">The Principles <span>That Drive</span> Us</h2>
          <span className="about-values-accent" aria-hidden="true" />
        </header>

        <div className="about-values-grid" role="list">
          {values.map(({ title, text, Icon }) => (
            <article className="about-values-card" key={title} role="listitem">
              <span className="about-values-card-icon">
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AboutValuesSection
